export enum InstanceTypes {
    //Informate = '1e4b2e58-88bb-448b-8ce5-dc34c5d3f3ae',
    ICE = 'ee07b6bf-cbd9-4306-a4ab-0a57c3fe60a8',
    cDMS = 'b90f9734-009a-437e-b27b-22801dc8cda8',
    iDMS = '2e4b2e58-88bb-448b-8ce5-dc34c5d3f3ad',
}
